import {Component} from '@angular/core';

@Component({
  selector: 'em-profile-decision-popup-header',
  template: ` <div class="flex gap-4 mb-7 h-2rem justify-content-center">
    <img src="assets/insurance-logos/EMMA.svg" alt="emma-logo" />
    <img src="assets/insurance-logos/HUMANIA.svg" alt="humania-logo" />
  </div>`,
})
export class ProfileDecisionPopupHeaderComponent {}
